import React from "react";
import { Navigate } from "react-router-dom";
import errorStatus2 from "../assets/Error2.png";
import "../App.css";
import "../setnewpassword.css"

// the login form will display if there is no session token stored.  This will display
// the login form, and call the API to authenticate the user and store the token in
// the session.

export default class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      password: "",
      ncancelClicked: false,
      nsubmitClicked: false,
      tokenError: false,
      passwordError: false,
      genError: false,
      genRet: "",
    };
  }

  tokenChangeHandler = event => {

    // Local error
    if (event.target.value === "") {
      this.setState({
        tokenError: true
      });
      return;
    } else {
      this.setState({
        tokenError: false,
        token: event.target.value
      });
    }
  };

  newPasswordChangeHandler = event => {
    if (event.target.value === "") {
      this.setState({
        passwordError: true
      });
      return;
    } else {
      this.setState({
        passwordError: false,
        password: event.target.value
      });
    }
  };

  onCancel = () => {
    this.setState({
      ncancelClicked: true
    })
  }

  // when the user hits submit, process the login through the API
  submitHandler = event => {
    //keep the form from actually submitting
    event.preventDefault();

    //Michaels Error stuffs 

    //Password check
    if (this.state.password === "") {
      this.setState({
        passwordError: true
      });
      return;
    } else {
      this.setState({
        passwordError: false
      });
    }

    if (this.state.token === "") {
      this.setState({
        tokenError: true
      });
      return;
    } else {
      this.setState({
        tokenError: false
      });
    }
    event.preventDefault();

    //make the api call to the authentication page
    fetch(process.env.REACT_APP_API_PATH + "/auth/reset-password", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: this.state.token,
        password: this.state.password
      })
    }).then(updateSubmit => {

      //Error and if good get out of here!!!!
      if (!updateSubmit.ok) {
        this.setState({
          tokenError: true,
          passwordError: true,
          genError: true,
          genRet: "Please enter a valid token or password!"
        });
        return;
      } else {
        this.setState({
          nsubmitClicked: true,
        });
      }
    })
    event.target.reset();
  };

  render() {
    // console.log("Rendering login, token is " + sessionStorage.getItem("token"));
    return (
      <form onSubmit={this.submitHandler} className="setnewpasswordform">
        <div class="newpasswordcontainer">

          <div class="titlebox">
            <p class="logintitle">Set New Password</p>
          </div>
          <div class="instructionbox">
            <p id="snpf-instructions">Enter the token that was emailed to you and enter a new password.</p>
          </div>

          {this.state.genError ? <div className="errormess"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">{this.state.genRet}</div></div> : ""}

          <div class="tokenbox">
            <label for="snpf-tokenfield">Token</label>
            <input className={this.state.tokenError ? "errorBoxes" : "loginfield"} id="snpf-tokenfield" type="text" onChange={this.tokenChangeHandler} />
          </div>

          {this.state.tokenError ? <div className="errormess" ><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Invalid token!</div></div> : ""}

          <div class="newpasswordbox">
            <label for="snpf-newpasswordfield">New Password</label>
            <input className={this.state.passwordError ? "errorBoxes" : "loginfield"} id="snpf-newpasswordfield" type="password" onChange={this.newPasswordChangeHandler} />
          </div>

          {this.state.passwordError ? <div className="errormess"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Enter a valid password!</div></div> : ""}

          <div class="submissionbox">
            <input type="submit" value="Submit" className="loginbutton" />
            <input type="reset" value="Cancel" className="cancelbutton" onClick={this.onCancel} />
            {this.state.ncancelClicked ? <Navigate to="/forgotpassword" /> : ""}
            {this.state.nsubmitClicked ? <Navigate to="/login" /> : ""}
          </div>

        </div>
      </form>
    );
  }
}
